import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "status" ];

  ajaxResponse(event) {
    this.statusTarget.innerHTML = event.target.responseText;
  }

  sendAjax(event) {
    const form = event.originalTarget;
    const ajaxUrl = form.dataset.url;

    if (ajaxUrl) {
      event.preventDefault();
      let data = new FormData(form);

      let xhr = new XMLHttpRequest();
      xhr.open("POST", ajaxUrl);
      xhr.addEventListener("load", this.ajaxResponse.bind(this));
      xhr.send(data);
    }
  }
}
